export default "__VITE_ASSET__BDjWXFoJ__"